import React, { useCallback } from 'react';
import { useLazyGetEntityListItemsCsvFileQuery } from '../../apiEntityLists';
import AdministrationItemsDownloadButton from '../../../common/buttons/AdministrationItemsDownloadButton';

interface EntityListItemsDownloadButtonProps {
  entityListId: number;
  disabled?: boolean;
}

/**
 * Button to download entity list items as CSV file. Available to all entity list types (user, integration, etc.)
 * @param entityListId
 * @param disabled
 * @constructor
 */
const EntityListItemsDownloadButton: React.FC<EntityListItemsDownloadButtonProps> = ({
  entityListId,
  disabled = false,
}) => {
  const [trigger] = useLazyGetEntityListItemsCsvFileQuery();

  const downloadHandler = useCallback(() => {
    return trigger({ entityListId }).unwrap();
  }, [entityListId, trigger]);

  return (
    <AdministrationItemsDownloadButton
      triggerDownload={downloadHandler}
      fileName={`EntityList_${entityListId}_Items.zip`}
      disabled={disabled}
    />
  );
};

export default EntityListItemsDownloadButton;
